import * as React from 'react';
import { TranslationsContext } from '@telia-common-components/shared';
import { Separator, Notice } from 'telia-front-react';
import { shouldShowOversoldWarning } from '../util/InternetOfferUtil';
export const InternetOversoldWarning = (props) => {
    const translate = React.useContext(TranslationsContext).translate;
    if (!shouldShowOversoldWarning(props.internetOfferCards, props.isDealer)) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Separator, { spacing: "small", color: "invisible" }),
        React.createElement(Notice, { type: "employee" }, translate('internetCalculator.f4gOverloadedWarning')),
        React.createElement(Separator, { spacing: "small", color: "invisible" })));
};
